import React from "react";

const Order=props=>{
  const ingredientSummary=props.order.ingredients.map(item=>{
    return(
      <span style={{
        border: "1px solid grey",
        borderRadius: "5px",
        padding: "5px",
        marginRight: "10px",
        backgroundColor:"white"
    }}
      key={item.type}>{item.amount} * <span style={{textTransform:"capitalize"}}>{item.type}</span></span>
      )
  })
  return(
    <div style={{
      border: "1px solid grey",
      boxShadow: "1px 1px #888888",
      borderRadius: "5px",
      padding: "20px",
      marginBottom: "10px",
      backgroundColor:"#D70F64"
  }}>
      <p style={{
         border: "1px solid grey",
      boxShadow: "1px 1px #888888",
      borderRadius: "5px",
      padding: "20px",
      marginBottom: "10px",
      backgroundColor:"pink"

      }}>Order Number={props.order.id}</p>
      <p style={{
         border: "1px solid grey",
      boxShadow: "1px 1px #888888",
      borderRadius: "5px",
      padding: "20px",
      marginBottom: "10px",
      backgroundColor:"green"
      }}>Delivery Address:{props.order.customer.deliveryAddress}</p>
      <hr/>
      {ingredientSummary}
      <hr/>
      <p style={{ border: "1px solid grey",
      boxShadow: "1px 1px #888888",
      borderRadius: "5px",
      padding: "20px",
      marginBottom: "10px",
      backgroundColor:"yellow"}}>Total:{props.order.price} BDT</p>
      <p style={{
         border: "1px solid grey",
      boxShadow: "1px 1px #888888",
      borderRadius: "5px",
      padding: "20px",
      marginBottom: "10px",
      backgroundColor:"wheat"
      }}>{props.order.orderTime}</p>

    </div>
    )
}

export default Order;